"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var format_price_1 = __importDefault(require("../../utils/format-price"));
var unavailable_regions_1 = require("../../utils/unavailable-regions");
var UpsellCard = function (_a) {
    var _b;
    var product = _a.product, variant = _a.variant, baseProperties = _a.baseProperties, nameOverride = _a.nameOverride, setAddingState = _a.setAddingState;
    // if the variant name in the card is overridden, use that. otherwise, use the variant name
    var variantName = nameOverride || variant.name.split(/\(.+?\)/).join('');
    // if the product doesn't have variants, use the main product image
    var cardImage = variant.title === 'Default Title' ? product.image.src : (_b = variant.featured_image) === null || _b === void 0 ? void 0 : _b.src;
    var addToCart = function () { return __awaiter(void 0, void 0, void 0, function () {
        var properties;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    setAddingState(true);
                    // only selling upsells to Diaper Bundles, so bundleType can be set to 'Diaper' // TODO: this is no longer true
                    (_a = window.dataLayer) === null || _a === void 0 ? void 0 : _a.push(__assign(__assign({ event: 'cartUpsells__productsAdded', bundleType: 'Diaper' }, variant), { product_variant_title: "".concat(product.title, " - ").concat(variant.title) }));
                    properties = (0, unavailable_regions_1.addUnavailableRegionsToCartLineProperties)(baseProperties || {}, product.tags.split(','));
                    return [4 /*yield*/, window.cartApp.add([[variant.id, { properties: __assign(__assign({}, properties), { compare_at_price: Number(variant.compare_at_price) * 100 }) }]])];
                case 1:
                    _b.sent();
                    setAddingState(false);
                    return [2 /*return*/];
            }
        });
    }); };
    return (react_1.default.createElement("div", { className: 'bg-transparent-light-wisteria bordered border-wisteria text-center margin-horizontal-1 padding-horizontal-1 padding-vertical-3 font-size-12', style: { height: '200px', display: 'flex', justifyContent: 'space-between', flexDirection: 'column' } },
        react_1.default.createElement("div", null,
            react_1.default.createElement("img", { src: cardImage, style: { maxHeight: '80px', margin: '0 auto' }, alt: 'Product image' }),
            react_1.default.createElement("div", { className: 'font-bold text-dark-grey width-100 margin-top-1', 
                // a bunch of weird css styles that somehow produce a "truncate with ellipsis after 2 lines" effect https://stackoverflow.com/a/30940678
                style: { fontSize: '11px', letterSpacing: '1px', WebkitLineClamp: 2, overflow: 'hidden', display: '-webkit-box', WebkitBoxOrient: 'vertical' } }, variantName),
            react_1.default.createElement("div", null,
                react_1.default.createElement("span", { className: 'text-wisteria' }, (0, format_price_1.default)(variant.price)),
                react_1.default.createElement("span", { className: 'padding-left-2 strike text-gray' }, (0, format_price_1.default)(variant.compare_at_price)))),
        react_1.default.createElement("div", null,
            react_1.default.createElement("button", { id: 'add-upsell-product' // for GA
                , onClick: addToCart, className: 'text-wisteria font-bold border-wisteria bordered padding-horizontal-3 medium-padding-5 padding-vertical-2' }, "+ Add"))));
};
exports.default = UpsellCard;
